import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioItem, DEFAULT_RADIO_CONFIG, RadioConfig, DEFAULT_RADIO_ITEM } from './radio.modal';

@Component({
  selector: 'ds-radio-button',
  templateUrl: './radio-button.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class RadioButtonComponent implements OnChanges {
  @Input() items: RadioConfig = DEFAULT_RADIO_CONFIG;

  public groupName = 'ds-radio-' + Math.random().toString(36).substr(2, 6);

  @Output() selectedChange = new EventEmitter<RadioItem>();

  ngOnChanges(changes: SimpleChanges): void {
    this.items.options = (this.items.options || []).map(it => ({ ...DEFAULT_RADIO_ITEM, ...(it || {}) }));
  }

  onClick(event: Event, index: number) {
    this.items?.options?.forEach((it, idx) => it.checked = idx === index);
    this.selectedChange.emit(this.items?.options[index]);
  }
}